import type { GPTModuleConfig } from "@/ts/module";
export const carouselAdSizesGPT: Pick<GPTModuleConfig, "adSizesGPT"> = {
    adSizesGPT: {
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-1-3": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-1-6": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-1-9": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-1-12": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-1-15": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-1-18": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-1-21": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-1-24": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-1-27": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-1-30": [[300, 250]],
        "div-gpt-ad-mantis-carousel-lb-mantis-ui-widget-1-1": [
            [320, 100],
            [320, 50],
            [300, 100],
            [300, 50],
        ],
        "div-gpt-ad-mantis-carousel-lb-mantis-ui-widget-1-2": [
            [320, 100],
            [320, 50],
            [300, 100],
            [300, 50],
        ],
        "div-gpt-ad-mantis-carousel-lb-mantis-ui-widget-1-3": [
            [320, 100],
            [320, 50],
            [300, 100],
            [300, 50],
        ],
        "div-gpt-ad-mantis-carousel-lb-mantis-ui-widget-1-4": [
            [320, 100],
            [320, 50],
            [300, 100],
            [300, 50],
        ],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-2-3": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-2-6": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-2-9": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-2-12": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-2-15": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-2-18": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-2-21": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-2-24": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-2-27": [[300, 250]],
        "div-gpt-ad-mantis-carousel-mpu-mantis-ui-widget-2-30": [[300, 250]],
    },
};
